import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PickUpAdapter } from './dto/pickup.adapter';
import { PickUpController } from './pickup.controller';
import { PickUp } from './pickup.entity';
import { PickUpService } from './pickup.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([PickUp]),
  ],
  controllers: [PickUpController],
  providers: [PickUpService, PickUpAdapter, ApplicationExceptionHandler,LogsService],
  exports: [PickUpService]
})
export class PickupModule {}